import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import api from '@/api';
export default {
  name: "payOrderList",
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      pagingReqFn: "payOrderList",
      paramsData: {
        isMustAppid: 1,
        third_part_pay_type: ''
      },
      dateTypeKey: 'month',
      orderStatus: [{
        label: "订单被创建",
        value: 1
      }, {
        label: "订单被回调",
        value: 2
      }, {
        label: "回调处理成功",
        value: 3
      }, {
        label: "回调处理失败",
        value: 4
      }, {
        label: "预下单成功",
        value: 5
      }, {
        label: "订单成功",
        value: 6
      }, {
        label: "已补单",
        value: 7
      }],
      deliverStatus: [{
        label: "未回调网关",
        value: 1
      }, {
        label: "开始回调网关",
        value: 2
      }, {
        label: "回调网关成功",
        value: 3
      }, {
        label: "回调网关失败",
        value: 4
      }, {
        label: "回调网关次数超过允许值",
        value: 5
      }],
      payData: []
    };
  },
  created: function created() {
    this.getTodayRange(this.dateType);
  },
  activated: function activated() {
    this.getcommonData(['appListAllData', 'appPaymentTypeAllData']);
  },
  methods: {
    payTypeChange: function payTypeChange(e) {
      if (e.length) {
        this.paramsData.third_part_pay_type = e.join(",");
      } else {
        this.paramsData.third_part_pay_type = '';
      }
    },
    exportDataFn: function exportDataFn() {
      var _this = this;

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page: 1,
        page_size: this.total + 10
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: '网关用户ID',
            prop: 'gate_user_id'
          }, {
            label: '登录用户ID',
            prop: 'login_user_id'
          }, {
            label: '研发用户ID',
            prop: 'developer_user_id'
          }, {
            label: '网关订单号',
            prop: 'gate_order_id'
          }, {
            label: '支付订单ID',
            prop: 'pay_order_id'
          }, {
            label: '研发订单ID',
            prop: 'developer_order_id'
          }, {
            label: '设备ID',
            prop: 'device_id'
          }, {
            label: '支付平台类型ID',
            prop: 'third_part_pay_type_id'
          }, {
            label: '支付平台类型',
            prop: 'third_part_pay_type'
          }, {
            label: '支付渠道订单ID',
            prop: 'third_part_order_id'
          }, {
            label: '服务器ID',
            prop: 'server_id'
          }, {
            label: '游戏内商品',
            prop: 'product'
          }, {
            label: '商品名称',
            prop: 'product_name'
          }, {
            label: '商品描述',
            prop: 'product_desc'
          }, {
            label: '商品价格(元)',
            prop: 'price'
          }, {
            label: '支付平台商品',
            prop: 'third_part_product'
          }, {
            label: '游戏内商品价格(元)',
            prop: 'third_part_price'
          }, {
            label: '订单状态',
            prop: 'order_state'
          }, {
            label: '网关状态',
            prop: 'deliver_state'
          }, {
            label: '回调网关次数',
            prop: 'deliver_times'
          }, {
            label: '创建时间',
            prop: 'create_time'
          }, {
            label: '被回调时间',
            prop: 'callback_time'
          }, {
            label: '最新分发时间',
            prop: 'deliver_time'
          }, {
            label: '成功处理时间',
            prop: 'success_time'
          }, {
            label: '支付平台订单凭证',
            prop: 'prepay_id'
          }, {
            label: '预下单时间',
            prop: 'prepare_time'
          }, {
            label: '支付IP',
            prop: 'ip'
          }, {
            label: '小程序用户ID',
            prop: 'open_id'
          }];
          var data = res.data.data;
          data.forEach(function (item) {
            item.price = _this.$utils.conversion(item.price);
            item.third_part_price = _this.$utils.conversion(item.third_part_price);
            item.order_state = item.order_state ? _this.orderStatus.find(function (i) {
              return i.value == item.order_state;
            }).label : '/';
            item.deliver_state = item.deliver_state ? _this.deliverStatus.find(function (i) {
              return i.value == item.deliver_state;
            }).label : '/';
            item.create_time = item.create_time ? _this.$times.timestampToTime(item.create_time) : '/';
            item.callback_time = item.callback_time ? _this.$times.timestampToTime(item.callback_time) : '/';
            item.deliver_time = item.deliver_time ? _this.$times.timestampToTime(item.deliver_time) : '/';
            item.success_time = item.success_time ? _this.$times.timestampToTime(item.success_time) : '/';
            item.prepare_time = item.prepare_time ? _this.$times.timestampToTime(item.prepare_time) : '/';
          });

          _this.$export.excel({
            columns: columns,
            data: data,
            title: _this.$route.meta.title
          });
        }
      });
    },
    hndleRepairOrder: function hndleRepairOrder(row) {
      var _this2 = this;

      this.$confirm('是否确认补单?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$api.repairOrder({
          pay_order_id: row.pay_order_id,
          appid: row.appid,
          isMustAppid: 1
        }).then(function (res) {
          if (res.status == 200) {
            _this2.$message.success('补单成功');

            _this2.getList();
          } else {
            _this2.$message.error('补单失败');
          }
        });
      });
    }
  }
};